import { Injectable, signal, inject, DestroyRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

export interface FutureUser {
  id: string | number;
  fullName: string;
  username?: string;
}

export interface ClearanceUser {
  userId: number | string; // what your API returns; we’ll normalize to number
  email: string;
  name?: string;
}



@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private router = inject(Router);
  private destroyRef = inject(DestroyRef)

  showCategory = signal<boolean>(false);
  selectedUser = signal<string>('');
  private selectedUserSubject = new BehaviorSubject<FutureUser | null>(null);
  selectedUser$ = this.selectedUserSubject.asObservable();
  // add this
  selectedProduct = signal<string>('');
  showClassification = signal<boolean>(false);

  private key = 'selectedClearanceUserId';
  // private subject = new BehaviorSubject<number | null>(this.read());

  // selectedId$ = this.subject.asObservable();


  constructor() {
    // Watch for route changes and clear search on home/shop
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((e) => {
        const url = (e.urlAfterRedirects || e.url).split('?')[0]; // ignore query params
        if (url === '/' || url.startsWith('/shop')) {
          this.clearSearch();
        }
      });
  }


  setShowCategory(value: boolean) {
    this.showCategory.set(value);
  }

  toggleShowCategory() {
    this.showCategory.update(current => !current);
  }

  set(user: FutureUser | null) {
    this.selectedUserSubject.next(user);
  }

  get snapshot(): FutureUser | null {
    return this.selectedUserSubject.value;
  }


  setShowClassification(value: boolean) {
    this.showClassification.set(value);
    localStorage.setItem('showClassification', String(value));
  }

  // Optional: restore from localStorage on app start
  restoreFromStorage() {
    const raw = localStorage.getItem('showClassification');
    this.showClassification.set(raw === 'true');
  }


  clear() {
    this.selectedUserSubject.next(null);
  }

  clearSearch() {
    this.selectedProduct.set('');
  }

  // setClearance(id: number | null) {
  //   this.subject.next(id); this.write(id);
  // }

  // get snapshotClearance(): number | null {
  //   return this.subject.value;
  // }

  // clearClearance() {
  //   this.set(null);
  // }
  // private read(): number | null {
  //   try {
  //     const raw = sessionStorage.getItem(this.key);
  //     if (!raw) return null;
  //     const n = Number(raw);
  //     return Number.isFinite(n) ? n : null;
  //   } catch {
  //     return null;
  //   }
  // } private write(id: number | null) {
  //   try {
  //     if (id == null) sessionStorage.removeItem(this.key);
  //     else sessionStorage.setItem(this.key, String(id));
  //   } catch { }
  // }

}